export const GET_LIVE_BOOKINGS_REQUEST = "GET_LIVE_BOOKINGS_REQUEST";
export const GET_LIVE_BOOKINGS_SUCCESS = "GET_LIVE_BOOKINGS_SUCCESS";
export const GET_LIVE_BOOKINGS_FAILURE = "GET_LIVE_BOOKINGS_FAILURE";

export const getLiveBookingsRequest = (payload: {
    branchid: string;
    filtervalue?: string;
}) => ({
    type: GET_LIVE_BOOKINGS_REQUEST,
    payload,
});

export const getLiveBookingsSuccess = (payload: any) => ({
    type: GET_LIVE_BOOKINGS_SUCCESS,
    payload,
});

export const getLiveBookingsFailure = (error: string) => ({
    type: GET_LIVE_BOOKINGS_FAILURE,
    payload: error,
});

//reassign trip
export const REASSIGN_TRIP_REQUEST = "REASSIGN_TRIP_REQUEST";
export const REASSIGN_TRIP_SUCCESS = "REASSIGN_TRIP_SUCCESS";
export const REASSIGN_TRIP_FAILURE = "REASSIGN_TRIP_FAILURE";
export const REASSIGN_TRIP_RESET = "REASSIGN_TRIP_RESET";

export const reassignTripRequest = (payload: {
    cabid: string;
    oldcabid: string;
    bookid: number;
    driverid: string;
    reassignby: string;
    emptyKM: number;
    reason: string;
}) => ({
    type: REASSIGN_TRIP_REQUEST,
    payload,
});

export const reassignTripSuccess = (payload: any) => ({
    type: REASSIGN_TRIP_SUCCESS,
    payload,
});

export const reassignTripFailure = (error: any) => ({
    type: REASSIGN_TRIP_FAILURE,
    payload: error,
});

export const reassignTripReset = () => ({
    type: REASSIGN_TRIP_RESET,
});

// autoCompleteActionTypes.ts

export const AUTO_COMPLETE_REQUEST = "AUTO_COMPLETE_REQUEST";
export const AUTO_COMPLETE_SUCCESS = "AUTO_COMPLETE_SUCCESS";
export const AUTO_COMPLETE_FAILURE = "AUTO_COMPLETE_FAILURE";
export const AUTO_COMPLETE_RESET = "AUTO_COMPLETE_RESET";


export const autoCompleteRequest = (payload: any) => ({
    type: AUTO_COMPLETE_REQUEST,
    payload,
});

export const autoCompleteSuccess = (payload: any) => ({
    type: AUTO_COMPLETE_SUCCESS,
    payload,
});

export const autoCompleteFailure = (error: any) => ({
    type: AUTO_COMPLETE_FAILURE,
    payload: error,
});

export const autoCompleteReset = () => ({
    type: AUTO_COMPLETE_RESET,
});